import { LoanRequest, LoanRequestInsurance } from '../../types/authorization';

export const getInsuranceForms = (loanRequest: LoanRequest) => {
  const insurancesWithForms = loanRequest.loanRequestInsurances.filter(
    (lrInsurance) => lrInsurance.insurance.formSchema !== null
                    && Object.keys(lrInsurance.insurance.formSchema).length > 0,
  );
  return insurancesWithForms;
};

export const getInitialResponses = (
  insurancesWithForms: LoanRequestInsurance[],
  loanRequest: LoanRequest,
) => {
  const initialResponses: Record<string, Record<string, any>> = {};
  insurancesWithForms.forEach((lrInsurance) => {
    initialResponses[lrInsurance.id] = {};

    if (lrInsurance.insurance.formSchema && lrInsurance.insurance.formSchema.fields) {
      const prefilledFields = loanRequest.loanRequestInsurances
        .find((lri) => lri.insurance.id === lrInsurance.insurance.id)?.formResponse;
      lrInsurance.insurance.formSchema.fields.forEach((field) => {
        initialResponses[lrInsurance.id][field.label] = prefilledFields?.response
          .find((fr: { label: string, response: boolean }) => fr.label === field.label)?.response.toString() ?? '';
      });
    }
  });

  return initialResponses;
};

export const isCurrentFormComplete = (
  activeStep: number,
  insuranceForms: LoanRequestInsurance[],
  formResponses: Record<string, Record<string, any>>,
) => {
  if (activeStep >= insuranceForms.length) return true;

  const currentInsurance = insuranceForms[activeStep];
  if (!currentInsurance) return true;

  const fields = Object.keys(formResponses[currentInsurance.id] || {});
  return fields.every((field) => formResponses[currentInsurance.id][field] !== '');
};
